import type { ReactNode } from 'react';

export type Section = 'calendar' | 'report' | 'team' | 'tasks' | 'settings' | 'help' | null;

export type RouteHeading = {
    title: string;
    subtitle: ReactNode;
};

export const isMonthAwareSection = (section: Section): boolean => section === 'calendar' || section === 'report';

export const sectionFromPath = (pathname: string): Section => {
    if (pathname.startsWith('/calendar/')) {
        return 'calendar';
    }
    if (pathname.startsWith('/report/') || pathname === '/report') {
        return 'report';
    }
    if (pathname === '/team' || pathname.startsWith('/team/')) {
        return 'team';
    }
    if (pathname === '/tasks' || pathname.startsWith('/tasks/')) {
        return 'tasks';
    }
    if (pathname === '/settings' || pathname.startsWith('/settings/')) {
        return 'settings';
    }
    if (pathname === '/help' || pathname.startsWith('/help/')) {
        return 'help';
    }
    return null;
};

export const headingForSection = (section: Section, firstName: string | null): RouteHeading | null => {
    switch (section) {
        case 'calendar':
            return {
                title: firstName ? `${firstName}’s Calendar` : 'Calendar',
                subtitle: (
                    <>
                        Plan and log hours against <em>your work items</em> for the month.
                    </>
                ),
            };
        case 'report':
            return {
                title: 'Report',
                subtitle: (
                    <>
                        Track <em>team capacity</em>, logged hours and status.
                    </>
                ),
            };
        case 'team':
            return {
                title: 'Team',
                subtitle: (
                    <>
                        Manage your <em>team members</em> and their access.
                    </>
                ),
            };
        case 'tasks':
            return {
                title: 'Tasks',
                subtitle: (
                    <>
                        Manage <em>recurring tasks</em> and one-time data updates.
                    </>
                ),
            };
        case 'settings':
            return {
                title: 'Settings',
                subtitle: (
                    <>
                        Configure your <em>Azure DevOps</em> connection.
                    </>
                ),
            };
        case 'help':
            return {
                title: 'Help',
                subtitle: (
                    <>
                        How the <em>time tracker</em> works and where to find things.
                    </>
                ),
            };
        default:
            return null;
    }
};
